<template>
<div class="sl-switcher">
  <div class="sl-btn" v-for="(item,index) in switchArray" :class="{'sl-btn-active':index === switchActive}" @click="handleSwitcher(index)" :key="index">{{item.label}}</div>
</div>
</template>

<script>
import * as types from '../store/types'
export default {
  name: 'sl-switcher',
  data() {
    return {
      switchArray: [{
        label: this.$t('Date.today'),
        value: 'hour'
      }, {
        label: this.$tc('Date.dateRange', 0),
        value: 'week'
      }, {
        label: this.$tc('Date.dateRange', 1),
        value: 'month'
      }, {
        label: this.$tc('Date.dateRange', 2),
        value: 'year'
      }],
      switchActive: 0
    }
  },
  methods: {
    handleSwitcher(index) {
      this.$ga.event('Button', 'DateSwitcher:' + this.switchArray[index].value, 'Dashboard')
      this.switchActive = index
      this.$store.commit(types.ACTIVETIME, this.switchArray[index].value)
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 1100px) and (min-width: 900px) {
  div.sl-switcher {
    text-align: left;
  }
}

.sl-switcher {
  /* text-align: center; */
  /* padding: 20px 0; */
  /* position: fixed; */
  /* width: calc(100% - 170px); */
  /* background: #FFF; */
  /* z-index: 990; */
  display: flex;
  align-items: center;
  /* width: 100%; */
}

.sl-btn {
  font-family: Avenir-Roman;
  font-size: 15px;
  color: #606266;
  letter-spacing: 0;
  line-height: 28px;
  display: inline-block;
  height: 40px;
  background-color: #FFFFFF;
  /* margin: 0 27px; */
  cursor: pointer;
  border: 1px solid #DCDFE6;
  padding: 5px 30px;
  margin: -1px;
}

.sl-switcher > :first-child{
  border-radius: 5px 0 0 5px;
}
.sl-switcher > :last-child{
  border-radius: 0 5px 5px 0 ;
}

.sl-btn:hover {
  color: #20a0ff;
}

.sl-btn.sl-btn-active {
  color: #FFFFFF;
  background-color: #20a0ff;
  border: 1px solid #20a0ff;
  /* border-bottom: 2px solid #4990E2; */
}

@media screen and (orientation:portrait) and (max-width: 768px) {
  .sl-btn {
    font-size: 13px;
    padding: 5px 24px;
  }
}

@media screen and (orientation:portrait) and (max-width: 640px) {
  .sl-btn {
    font-size: 12px;
    padding: 5px 8px;
    margin: 0 auto;;
  }
}

@media screen and (orientation:portrait) and (max-width: 320px) {
  .sl-btn {
    font-size: 12px;
    padding: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// sl-switcher.vue?31c56654